"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vignale-monferrato": {
    "29d0b2bd": [{
      "hkey": "a469c9e3",
      "slug": "vignale-monferrato",
      "name": "Vignale Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "bergantino": [{
      "hkey": "a469c9e3",
      "slug": "vignale-monferrato",
      "name": "Vignale Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6d3159a5": [{
      "hkey": "a469c9e3",
      "slug": "vignale-monferrato",
      "name": "Vignale Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "molignano": [{
      "hkey": "a469c9e3",
      "slug": "vignale-monferrato",
      "name": "Vignale Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1cf59ad1": [{
      "hkey": "a469c9e3",
      "slug": "vignale-monferrato",
      "name": "Vignale Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "moretta": [{
      "hkey": "a469c9e3",
      "slug": "vignale-monferrato",
      "name": "Vignale Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;